/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "815b36e12f1acccfd7d055947e6e37e517c325d3";
